import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import { OrderOptimizerTaxiDetailsItemStatus } from "./types/order-optimizer-taxi-details-item";
import OrderOptimizerTaxiDetailsItemStatusSelectOption from "./types/order-optimizer-taxi-details-item-status-select-option";

const getStatusTranslation = (
  status: OrderOptimizerTaxiDetailsItemStatus,
): string => {
  const translations =
    orderOptimizerTranslationsHelper.getTaxiDetailsTranslations().status;

  switch (status) {
    case OrderOptimizerTaxiDetailsItemStatus.INTERESTING:
      return translations.interesting;
    case OrderOptimizerTaxiDetailsItemStatus.PENDING:
      return translations.pending;
    case OrderOptimizerTaxiDetailsItemStatus.REJECTED:
      return translations.rejected;
  }
};

const createSelectOption = (
  status: OrderOptimizerTaxiDetailsItemStatus,
): OrderOptimizerTaxiDetailsItemStatusSelectOption => {
  return {
    label: getStatusTranslation(status),
    value: status,
  };
};

const getSelectOptions = () => {
  return Object.values(OrderOptimizerTaxiDetailsItemStatus).map(
    createSelectOption,
  );
};

const orderOptimizerTaxiDetailsItemStatusSelectOptionFactory = {
  createSelectOption,
  getSelectOptions,
};

export default orderOptimizerTaxiDetailsItemStatusSelectOptionFactory;
